import { Row } from 'antd';
import clsx from 'clsx';
import { inverterInfo } from 'models';
import * as React from 'react';
import style from './InverterMenu.module.scss';
export interface InverterMenuProps {
  setIsShowItem: (value: string) => void;
  isShowItem: string;
  inverterConfig: any;
  objectInverter?: inverterInfo;
}

export default function InverterMenu({
  isShowItem,
  objectInverter,
  setIsShowItem,
  inverterConfig,
}: InverterMenuProps) {
  const [data, setData] = React.useState<any>([]);
  React.useEffect(() => {
    if (inverterConfig) {
      setData([
        {
          content: 'System Parameters',
          icon: 'System',
          display: inverterConfig?.system_control_panel.display,
        },
        {
          content: 'Power Control',
          icon: 'Power',
          display: inverterConfig?.power_control_panel.display,
        },
        {
          content: 'Protection Parameters',
          icon: 'Protection',
          display: inverterConfig?.protection_control_panel.display,
        },
      ]);
    }
  }, [inverterConfig]);
  return (
    <div className={style.root}>
      <div className={style.name_plant}>
        <div className={style.container_icon}>
          <div className={style.menuIconInverter}></div>
        </div>
        <p>{objectInverter?.label}</p>
      </div>
      <div className={style.sidebar_main_management}>
        {data.map((item: any, index: number) => (
          <Row
            align={'middle'}
            key={`menuPlant_${index}`}
            onClick={() => {
              setIsShowItem(item.content);
            }}
            className={clsx(style.item_sidebar_management, {
              [style.active]: isShowItem === item.content,
            })}
            style={{
              display: item.display ? 'flex' : 'none',
            }}
          >
            <div
              className={clsx(style.sidebar_item_icon, {
                [style.System]: 'System' === item.icon,
                [style.Power]: 'Power' === item.icon,
                [style.Protection]: 'Protection' === item.icon,
              })}
            ></div>
            {item.content}
          </Row>
        ))}
      </div>
    </div>
  );
}
